import { Observable } from 'rxjs/Observable';
import { Constant, BaseComponent, DatePickerFormatter } from '../../../../../../infrastructure/common';
import { Router, NavigationExtras } from '@angular/router';
import { Component, AfterViewInit } from '@angular/core';
import * as moment from 'moment';

import { OnlineOrderService } from '../../../../../../infrastructure/services/transaction/op/outbound/order';
import { AnnouncementService, AnnouncementStatusService } from 'app/infrastructure/services/transaction/op/announcement/index';

declare var jQuery: any;

@Component({
    selector: 'page-announcement-list',
    templateUrl: './announcement-list.html',
    styleUrls: [`./announcement-list.css`]
})

export class AnnouncementListComponent extends BaseComponent implements AfterViewInit {

    searchParams: any = {};
    announcementStatus: any[];
    owners: any[];
    announcementList: any[];
    selectedAnnouncement: any;

    isLoading: boolean = false;
    isLoadingStatusCode: boolean = false;
    isPermanentDelete: boolean = false;
    isLoadingOwner: boolean = false;

    constructor(private router: Router,
                private announcementService: AnnouncementService,
                private announcementStatusService: AnnouncementStatusService,
                private onlineOrderService: OnlineOrderService) {
        super();
    }

    ngOnInit(): void {
        let self = this;

        // load data
        let promiseList = [
            self.getAnnouncementStatusCode(),       // load Announcement Status list
            self.getOwnerList()                     // load owner list
        ];
        Promise.all(promiseList).then(() => {
            self.getAnnouncementList();
        });
    }

    ngAfterViewInit(): void {
        let self = this;

        jQuery('.mydatepicker').datepicker({
            autoclose: true,
            clearBtn: true,
            format: DatePickerFormatter.mapDateFormat(self.token.DateFormatDescription)
        }).on('change', (e) => {
            let dateFormat: string = self.token.DateFormatDescription.toUpperCase();
            let dateVal: Date = undefined;

            if (e.target.value) {
                dateVal = moment.utc(e.target.value, dateFormat).toDate();
            }
            self.searchParams[e.target.name] = dateVal;
        });

        jQuery('#search_txtFromCreateDate').datepicker().on('change', (e) => {
            let dateFormat: string = self.token.DateFormatDescription.toUpperCase();
            let fromDate: Date;
            let toDate: Date;

            fromDate = (e.target.value) ?
                            moment.utc(e.target.value, dateFormat).toDate() :
                            undefined;
            toDate = (jQuery('#search_txtToCreateDate').val()) ?
                        moment.utc(jQuery('#search_txtToCreateDate').val(), dateFormat).toDate() :
                        undefined;

            if (toDate < fromDate) {
                jQuery('#search_txtToCreateDate').datepicker('setDate', '');
            }

            if (fromDate) {
                jQuery('#search_txtToCreateDate').datepicker('setStartDate', fromDate);
            }
        });

        jQuery('#search_txtFromDate').datepicker().on('change', (e) => {
            let dateFormat: string = self.token.DateFormatDescription.toUpperCase();
            let fromDate: Date;
            let toDate: Date;

            fromDate = (e.target.value) ?
                            moment.utc(e.target.value, dateFormat).toDate() :
                            undefined;
            toDate = (jQuery('#search_txtToDate').val()) ?
                        moment.utc(jQuery('#search_txtToDate').val(), dateFormat).toDate() :
                        undefined;

            if (toDate < fromDate) {
                jQuery('#search_txtToDate').datepicker('setDate', '');
            }

            if (fromDate) {
                jQuery('#search_txtToDate').datepicker('setStartDate', fromDate);
            }
        });

        setTimeout(() => {
            jQuery('input[name=txtAnnCode]').focus();
        });
    }

    showDatePicker(idEl) {
        jQuery('#' + idEl).datepicker('show');
    }

    showNewAnnouncementPage() {
        this.router.navigate(['pages/new-announcement']);
    }

    showEditAnnouncementPage(announcement: any) {
        let navParams: NavigationExtras = {
            queryParams: { id: announcement.Id }
        };
        this.router.navigate(['pages/edit-announcement'], navParams);
    }

    showDeleteConfirmation(announcement: any) {
        this.selectedAnnouncement = announcement;
        this.isPermanentDelete = false;
        jQuery('#PopupConfirmOrderList').modal('show');
    }

    getAnnouncementStatusCode(): Promise<any> {
        let self = this;
        self.isLoadingStatusCode = true;

        return self.executeWebApi(self.announcementStatusService.getAnnouncementStatusByAll(true)).then(
            message => {
                self.isLoadingStatusCode = false;
                self.announcementStatus = message.Result;

                if (self.announcementStatus.length > 0) {
                    self.searchParams.AnnoucementStatusCode = self.announcementStatus[0].StatusCode;
                }
            },
            error => {
                self.isLoadingStatusCode = false;
            }
        );

        // let promise = new Promise((resolve, reject) => {
        //     self.isLoadingStatusCode = true;

        //     self.announcementStatusService.getAnnouncementStatusByAll(true)
        //         .subscribe(
        //             data => {
        //                 let message = data;
        //                 if (message && message.MessageType && message.MessageType.Value) {
        //                     if (message.MessageType.Value == Constant.MessageType.success) {
        //                         self.announcementStatus = message.Result;

        //                         if (self.announcementStatus.length > 0) {
        //                             self.searchParams.AnnoucementStatusCode = self.announcementStatus[0].StatusCode;
        //                         }
        //                     }
        //                     else {
        //                         self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //                     }
        //                 }
        //                 else {
        //                     self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //                 }
        //             },
        //             error => {
        //                 self.isLoadingStatusCode = false;
        //                 self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //                 reject();
        //             },
        //             () => {
        //                 self.isLoadingStatusCode = false;
        //                 resolve();
        //             }
        //         );
        // });

        // return promise;
    }

    getOwnerList(): Promise<any> {
        let self = this;
        self.isLoadingOwner = true;

        let groupId = self.token.GroupId;
        let isIncludeAll: boolean = true;
        return self.executeWebApi(self.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId, isIncludeAll)).then(
            message => {
                self.isLoadingOwner = false;
                self.owners = message.Result;
                self.searchParams.OwnerCode = 'ALL';
            },
            error => {
                self.isLoadingOwner = false;
            }
        );

        // let promise = new Promise((resolve, reject) => {
        //     self.isLoadingOwner = true;

        //     self.ownerService.getOwnerListByAll(true).subscribe(
        //         data => {
        //             let message = data;
        //             if (message && message.MessageType && message.MessageType.Value) {
        //                 if (message.MessageType.Value == Constant.MessageType.success) {
        //                     self.owners = message.Result;
        //                     self.searchParams.OwnerCode = 'ALL';
        //                 }
        //                 else {
        //                     self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //                 }
        //             }
        //             else {
        //                 self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //             }
        //         },
        //         error => {
        //             self.isLoadingOwner = false;
        //             self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //             reject();
        //         },
        //         () => {
        //             self.isLoadingOwner = false;
        //             resolve();
        //         }
        //     );
        // });

        // return promise;
    }

    getAnnouncementList(): void {
        let self = this;
        self.isLoading = true;

        self.executeWebApi(self.announcementService.getAnnouncementListByFilter(this.searchParams)).then(
            message => {
                self.isLoading = false;
                self.announcementList = message.Result;
            },
            error => {
                self.isLoading = false;
            }
        );

        // self.announcementService.getAnnouncementListByFilter(this.searchParams)
        //     .subscribe(
        //         data => {
        //             self.isLoading = false;

        //             let message = data;
        //             if (message && message.MessageType && message.MessageType.Value) {
        //                 if (message.MessageType.Value == Constant.MessageType.success) {
        //                     self.announcementList = message.Result;
        //                 }
        //                 else {
        //                     self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //                 }
        //             }
        //             else {
        //                 self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //             }
        //         },
        //         error => {
        //             self.isLoading = false;
        //             self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //         }
        //     );
    }

    saveAnnouncement(announcement: any): void {
        let self = this;
        self.isLoading = true;

        announcement.UpdatedBy = this.token.UserId;

        // update
        self.executeWebApi(self.announcementService.saveAnnouncement(announcement)).then(
            message => {
                self.isLoading = false;
                let updatedAnnouncement = message.Result;

                if (updatedAnnouncement) {
                    announcement = updatedAnnouncement;
                }
            },
            error => {
                self.isLoading = false;
            }
        );

        // // update
        // self.announcementService.saveAnnouncement(announcement).subscribe(
        //     data => {
        //         self.isLoading = false;

        //         let message = data;
        //         if (message && message.MessageType && message.MessageType.Value) {
        //             if (message.MessageType.Value == Constant.MessageType.success) {
        //                 let updatedAnnouncement = message.Result;

        //                 if (updatedAnnouncement) {
        //                     announcement = updatedAnnouncement;
        //                 }
        //             }
        //             else {
        //                 self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //             }
        //         }
        //         else {
        //             self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //         }
        //     },
        //     error => {
        //         self.isLoading = false;
        //         self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //     }
        // );
    }

    updateAnnouncementStatus(announcement: any): void {
        let isActive: boolean = (announcement.StatusCode == '2') ? true : false;
        announcement.StatusCode = (isActive) ? 1 : 2;
        announcement.UpdatedBy = this.token.UserId;

        this.saveAnnouncement(announcement);
    }

    deleteAnnouncement(isPermanentDelete: boolean) {
        jQuery('#PopupConfirmOrderList').modal('hide');

        let self = this;
        self.isLoading = true;

        if (isPermanentDelete) {
            // Permanent delete
            let id: number = self.selectedAnnouncement['Id'];
            self.executeWebApi(self.announcementService.deleteAnnouncement(id)).then(
                message => {
                    self.isLoading = false;

                    let itemIndex: number = self.announcementList.indexOf(self.selectedAnnouncement);
                    self.announcementList.splice(itemIndex, 1);
                },
                error => {
                    self.isLoading = false;
                }
            );

            // self.announcementService.deleteAnnouncement(self.selectedAnnouncement['Id']).subscribe(
            //     data => {
            //         self.isLoading = false;

            //         let message = data;
            //         if (message && message.MessageType && message.MessageType.Value) {
            //             if (message.MessageType.Value == Constant.MessageType.success) {
            //                 let itemIndex: number = self.announcementList.indexOf(self.selectedAnnouncement);
            //                 self.announcementList.splice(itemIndex, 1);
            //             }
            //             self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
            //         }
            //         else {
            //             self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
            //         }
            //     },
            //     error => {
            //         self.isLoading = false;
            //         self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            //     }
            // );
        }
        else {
            // delete
            self.selectedAnnouncement.StatusCode = 'X';
            self.selectedAnnouncement.UpdatedBy = self.token.UserId;
            self.saveAnnouncement(self.selectedAnnouncement);
        }
    }

    executeWebApi(fn: Observable<any>): Promise<any> {
        let self = this;
        let promise = new Promise((resolve, reject) => {
            fn.subscribe(
                message => {
                    if (message && message.MessageType && message.MessageType.Value) {
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            resolve(message);
                        }
                        else {
                            self.showMessage(message.MessageType.Value,
                                            message.MessageNumber,
                                            message.Message,
                                            message.AdditionalInformation);
                        }
                    }
                    else {
                        self.showMessage(Constant.MessageType.error,
                                        Constant.MessageNumber.defaultError,
                                        Constant.Message.defaultError,
                                        null);
                    }
                    reject();
                },
                error => {
                    self.showAlert(Constant.MessageType.error,
                                    Constant.MessageNumber.defaultError,
                                    Constant.Message.defaultError, error);
                    reject();
                },
                () => {}
            );
        });

        return promise;
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        jQuery('#PopupMessageTitle').html(title);
        jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
        jQuery('#PopupMessage').modal('show');
    }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/master/op/announcement/announcement-list/announcement-list.component.ts